import { useEffect, useState } from 'react';

import { usePlaycoinBoostModal } from '@/modals';

import { useUserActions } from '@/entities/user/model/user.store';
import { usePlaycoinWallet } from '@/entities/user/model/wallet.store';

import { getExpiredPlaycoinBooster } from '@/shared/api/user/user.api';

export const usePlaycoinBoostAlert = () => {
  const { isOpen, open } = usePlaycoinBoostModal();

  const playcoinWallet = usePlaycoinWallet();
  const { fetchUser } = useUserActions();

  const isExpiredBoosterExists = !!playcoinWallet?.isExpiredBoosterExists;

  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (isExpiredBoosterExists && !isOpen && !isLoading) {
      setIsLoading(true);
      getExpiredPlaycoinBooster()
        .then((booster) => {
          fetchUser();
          if (!!booster?.value && !!booster?.totalProfit) {
            open({
              boosterValue: booster.value,
              totalProfit: booster.totalProfit,
            });
          }
        })
        .catch((err) => {
          console.error(err);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isExpiredBoosterExists]);
};
